<template>
    <modal v-model="modalDiscount" dir="center" modalClass="sm" :title="`${canAddCoupon && canAddDiscount ? 'Cupón / Descuento' : (canAddCoupon ? 'Cupón' : 'Descuento')} ${isDiner  ? '('+isDiner .text+')' : ''}`">
        <div class="section" v-if="modalDiscount">
            <input-field
            v-model="modalDiscount.amount"
            :label="`${canAddCoupon && canAddDiscount ? 'Cupón / Descuento' : (canAddCoupon ? 'Cupón' : 'Descuento')}`"
            :description="`${canAddCoupon && canAddDiscount ? 'Ingresa el código de un cupón o el monto de descuento, puede ser un número fijo o un porcetaje' : (canAddCoupon ? 'Ingresa el código de un cupón' : 'Ingresa el monto de descuento, puede ser un número fijo o un porcetaje')}`"
            :placeholder="`${canAddCoupon && canAddDiscount ? '(Ejemplo: 20%)' : (canAddCoupon ? '' : '(Ejemplo: 20%)')}`">
            </input-field>

            <div :class="`well mt10 `" v-if="coupon && idTransaction">
                <div class="flex column fill">
                    <div class="flex fill">
                        <div class="flex column flex-fill">
                            <div class="bold">{{Util.CouponDiscountType(coupon)}}</div>
                            <div class="secondary-text"><span class="bold">Código: </span>{{coupon.code}}</div>
                        </div>
                        <div>
                            <i class="options icon-cross" v-tooltip="'Quitar cupón'" @click.stop="Confirm({
                                title: `¿Quitar cupón?`,
                                text: 'Quitar',
                                class: 'error-color',
                                function: () =>  {DeleteCouponDiscount(coupon)}
                            })"></i>
                        </div>
                    </div>
                </div>
            </div>

            <div :class="`well mt10 `" v-if="customDiscount && idTransaction">
                <div class="flex column fill">
                    <div class="flex fill">
                        <div class="flex column flex-fill">
                            <div class="bold">Dcto ingresado en caja</div>
                            <div class="secondary-text"><span class="bold">Valor: </span>{{Util.IsPrice(customDiscount)}}</div>
                        </div>
                        <div>
                            <i class="options icon-cross" v-tooltip="'Quitar descuento'" @click.stop="Confirm({
                                title: `¿Quitar descuento ingresado en caja?`,
                                text: 'Quitar',
                                class: 'error-color',
                                function: () =>  {DeleteCouponDiscount(customDiscount)}
                            })"></i>
                        </div>
                    </div>
                </div>
            </div>            

        </div>
        
        <!-- <button slot="actions" v-if="customDiscount" class="primary error-color" @click="DeleteCouponDiscount(customDiscount)">Eliminar</button> -->
        
        <!-- <button slot="actions" v-if="canAddDiscount" class="primary purple" @click="SetDiscount()">Ingresar <span v-if="canAddCoupon && modalDiscount && modalDiscount.amount.length >= 3" class="ml5">DCTO</span></button>
        <button v-if="(canAddCoupon && !canAddDiscount) || (canAddCoupon && modalDiscount.amount.length >= 3)" slot="actions" class="primary purple" @click="SetDiscount(null, true)">Ingresar Cupón</button> -->

        <button slot="actions" v-if="canAddDiscount" class="primary purple" @click="SetDiscount()">Ingresar DCTO</button>        
        <button v-if="canAddCoupon" slot="actions" class="primary purple" @click="SetCoupon()">Ingresar Cupón</button>
        
    </modal>
</template>
<script>
export default {
    props : {
        coupon : {
            type : Object,
            default : null
        },
        isDiner : {
            type: Object,
            default : null
        },
        idTransaction : { // Solo se envia cuando viene desde orders view (modal mesa)
            type : Number,
            default : null
        },
        selectedBrand : {
            type : Object,
            default : null
        }
        
    },
    data() {
        return {
            customDiscount : null,
            modalDiscount : null,
        }
    },
    methods : {
        SetDiscount()
        {
            var amount = this.modalDiscount.amount.trim().toUpperCase().replace('-', '').replace('X', '%');;
            
            if(!this.canAddDiscount) return this.Info('No se puede agregar descuento');
            if(!this.IsCustomDiscount(amount)) return this.Info('Cantidad inválida');

            if(this.idTransaction) {
                this.Loading();
                axios.post(`/transaction/${this.idTransaction}/discount/set`, {discount : this.customDiscount, diner : this.isDiner ? this.isDiner.value : 'ALL'})
                .then(res => {
                    this.Response(res);
                    this.customDiscount = amount;
                    this.$emit('UpdateDiscounts', this.customDiscount, 'save');
                    this.CloseModalDiscount();
                }).catch(err => {
                    this.Response(err);
                })
                return;
            }
            this.customDiscount = amount;
            this.$emit('UpdateDiscounts', this.customDiscount, 'save');
            this.CloseModalDiscount();

        },
        SetCoupon()
        {
            var code = this.modalDiscount.amount;
            //buscar codigo de cupon
            if(!this.canAddCoupon) return this.Info('No se puede agregar cupones de descuento');
            
            this.Loading();
            axios.post(`/coupon/${this.selectedBrand ? this.selectedBrand.id : this.Local.id}/code`, {code: code, id_transaction : this.idTransaction, diner : this.isDiner ? this.isDiner.value : 'ALL'}).then(res => {
                this.Response(res);
                this.$emit('UpdateDiscounts', res.data, 'save');
                this.CloseModalDiscount();
            }).catch(err => {
                this.Response(err);
            });
            return;
        },
        DeleteCouponDiscount(discount){
            if(this.idTransaction) {
                this.Loading();
                let data = {
                    'data' : {
                        'discount' : discount,
                        'diner' : this.isDiner ? this.isDiner.value : 'ALL'
                    }
                };
                axios.delete(`/transaction/${this.idTransaction}/discount/delete`, data)
                .then(res => {
                    // Elimina el desuento del objeto
                    this.$emit('UpdateDiscounts', discount, 'delete');
                    this.CloseModalDiscount();
                    this.Response(res); 

                }).catch(err => {
                    this.Response(err);
                })
                return;
            }
            this.$emit('UpdateDiscounts', discount, 'delete');
            this.CloseModalDiscount();
        },
        CloseModalDiscount() {
            this.modalDiscount = null;
            this.customDiscount = null;
        },
        IsCustomDiscount(str)
        {
            str = str ? str.trim() : str;
            if(!str) return false;
            const regex = /^-?\d+(?:[xX%])?$/;
            return regex.test(str);
        },
    },
    computed : {
        canAddDiscount() {
            return !!(this.Auth.role.indexOf('admin') > -1 || this.Auth.restrictions.apply_discount);
        },
        canAddCoupon() {
            return !!(this.Auth.role.indexOf('admin') > -1 || this.Auth.restrictions.apply_coupon);
        },
    }
}
</script>